
import { inject, Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { catchError, Observable, tap, throwError } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AnnotationsService {

  private baseUrl: string = `${environment["api_backend"]}/api`;
  private folderName: string | null = null;
  private handleError(error: any): Observable<never> {
    console.error("An error occurred:", error);
    return throwError(error);
  }

  constructor(private http: HttpClient) {}

  createTask(taskData: any): Observable<any> {
    console.log('Datos de la tarea a crear:', taskData);
    return this.http.post(`${this.baseUrl}/annotations/create-task`, taskData)
      .pipe(catchError(this.handleError));
  }
  
  uploadImages(formData: FormData) {
    return this.http
      .post<{ folderName: string }>(`${this.baseUrl}/gcs/upload`, formData)
      .pipe(tap((res) => (this.folderName = res.folderName)));
  }


  sendUrlsBucket(folderName: string, bucketName: string) {
    if (!this.folderName) throw new Error("folderName is not set");
    return this.http.post(`${this.baseUrl}/annotations/send-urls`, {
      folder: folderName,
      bucketName: bucketName
    });
  }
  
  sendCsv(formData: FormData) {
    return this.http
      .post(`${this.baseUrl}/annotations/urls-csv`, formData)
      .pipe(catchError(this.handleError));
  }
  


  initilizeProcess(body: {taskData: any, models: any}){
    console.log('datos que llegan al iniciar proceso', body)
    return this.http.post(`${this.baseUrl}/annotations/initialize-process`, body)
    .pipe(catchError(this.handleError))
  }

   
}
